import React, { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import Product from './Product';
import { Grid } from '@mui/material';

const ProductList = () => {
    const { user, isAuthenticated } = useAuth0();
    const [products, setProducts] = useState([]);

    useEffect(() => {
        const fetchPetsByOwner = async () => {
            if (isAuthenticated && user) {
                try {
                    const response = await fetch('/.netlify/functions/getProductsByOwner', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ userEmail: user.email }),
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }

                    const productData = await response.json();
                    // console.log("Fetched products:", productData);
                    setProducts(productData);
                } catch (error) {
                    console.error('Error fetching products:', error);
                }
            }
        };

        fetchPetsByOwner();
    }, [user, isAuthenticated]);

    return (
        <Grid container spacing={3}>
            {products.map((product) => {
                // console.log("Passing product to Product component:", product); // Add this line
                return (
                    <Grid item xs={12} md={4} key={product.id} style={{ minHeight: '500px' }}>
                        <Product productProp={product} />
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default ProductList;
